<template>
  <painel-component :items="itemsOne">
    <error-component :errors="errors" v-if="showError" />

    <div class="tabs effect-3" v-if="viewPage">
      <input type="radio" id="tab-1" name="tab-effect-3" checked />
      <span>
        <i class="info circle icon"></i>
        <span>Informações</span>
      </span>

      <input type="radio" id="tab-2" name="tab-effect-3" />
      <span>
        <i class="camera icon"></i>
        <span>Foto</span>
      </span>

      <div class="line ease"></div>
      <div class="tab-content">
        <section id="tab-item-1">
          <form>
            <row-component>
              <col-component
                class-col="col-xxl-9 col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.client_id }"
              >
                <label>Cliente:</label>
                <div class="input-container">
                  <input-component v-model="selectedClientName" placeholder="Cliente" disabled />
                  <button-submit class="btn-modal-search" icon="search" @click="openModalClient = true" />
                </div>
              </col-component>

              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.entry_date }"
              >
                <label>Data entrada:</label>
                <input-component v-mask="'##/##/####'" v-model="formData.entry_date" placeholder="00/00/0000" />
              </col-component>
            </row-component>

            <row-component>
              <col-component
                class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.bank }"
              >
                <label>Banco:</label>
                <MultiSelect v-model="formData.bank" placeholder="Banco" :options="selectBankList" />
              </col-component>

              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.agency }"
              >
                <label>Agência:</label>
                <input-component v-model="formData.agency" />
              </col-component>

              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.digit_account }"
              >
                <label>Conta/Dígito:</label>
                <input-component v-model="formData.digit_account" />
              </col-component>

              <col-component
                class-col="col-xxl-2 col-xl-2 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.value }"
              >
                <label>Valor:</label>
                <input-component v-model="formData.value" v-money="MONEY" />
              </col-component>
            </row-component>

            <row-component>
              <col-component
                class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.issuer_name }"
              >
                <label>Nome do emitente:</label>
                <input-component v-model="formData.issuer_name" />
              </col-component>

              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.number }"
              >
                <label>N° cheque:</label>
                <input-component v-model="formData.number" />
              </col-component>

              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.due_date }"
              >
                <label>Data vencimento:</label>
                <input-component v-mask="'##/##/####'" v-model="formData.due_date" placeholder="00/00/0000" />
              </col-component>
            </row-component>

            <row-component>
              <col-component
                class-col="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.email }"
              >
                <label>Email:</label>
                <input-component v-model="formData.email" />
              </col-component>

              <col-component
                class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.phone }"
              >
                <label>Telefone:</label>
                <input-component v-mask="['(##) ####-####', '(##) #####-####']" v-model="formData.phone" />
              </col-component>
            </row-component>

            <row-component>
              <col-component
                class-col="col-xxl-9 col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.description }"
              >
                <label>Descrição:</label>
                <text-area v-model="formData.description" />
              </col-component>

              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.status }"
              >
                <label>Status:</label>
                <MultiSelect v-model="formData.status" placeholder="Status" :options="selectStatusCheckManagement" />
              </col-component>
            </row-component>

            <row-component>
              <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <button-route class="w-100" :items="itemsTwo" />
              </col-component>

              <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <button-submit :disabled="sendForm" @click="submit" class="w-100" icon="save" name="Salvar" />
              </col-component>
            </row-component>
          </form>
        </section>

        <section id="tab-item-2">
          <div class="clearfix mb-3">
            <label class="btn-label btn float-end" for="check-photos">
              <i class="m-0 icon camera"></i>
              <input id="check-photos" multiple accept="image/*" @change="onFileChange" class="d-none" type="file" />
            </label>
          </div>

          <div class="alert alert-secondary fade show" role="alert" v-if="photos.length === 0">
            <p>Não há nada cadastrado</p>
          </div>

          <row-component v-else>
            <col-component
              class-col="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 px-3 mb-3"
              v-for="item in photos"
              :key="item.id"
            >
              <div class="card rounded-0">
                <img class="img-fluid" :src="item.link || item.photo" :alt="item.name_original || 'Foto'" />
                <div class="card-body p-2">
                  <p class="mb-1 text-truncate">{{ item.name_original || 'Imagem' }}</p>
                  <p class="mb-1 small text-muted">
                    {{ item.date_create }} {{ item.hour_create }}
                  </p>
                  <p class="mb-0 small text-truncate">{{ item.creator_user_name }}</p>
                </div>
                <div class="btn-group" role="group">
                  <button-delete @click="destroyPhoto(item)" />
                </div>
              </div>
            </col-component>
          </row-component>
        </section>
      </div>
    </div>

    <OrderPartClientSearch
      v-if="openModalClient"
      @close="openModalClient = false"
      @select="handleClientSelection"
    />
  </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import ColComponent from '@/components/row/ColComponent';
import InputComponent from '@/components/form/InputComponent';
import MultiSelect from '@/components/form/MultiSelect';
import TextArea from '@/components/form/TextArea';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ButtonDelete from '@/components/buttons/ButtonDelete';
import ErrorComponent from '@/components/alerts/ErrorComponent';
import OrderPartClientSearch from '@/components/modal/OrderPartClientSearch.vue';

import { VMoney } from 'v-money';
import { MONEY } from '@/configs/constants';
import { mask } from 'vue-the-mask';
import { useToast } from 'vue-toastification';
import swal from 'sweetalert';

const toast = useToast();
export default {
  name: 'CheckManagementUpdate',

  components: {
    ErrorComponent,
    ButtonDelete,
    ButtonRoute,
    ButtonSubmit,
    TextArea,
    MultiSelect,
    InputComponent,
    ColComponent,
    RowComponent,
    PainelComponent,
    OrderPartClientSearch
  },

  directives: {
    money: VMoney,
    mask
  },

  props: {
    id: {
      required: true
    }
  },

  created() {
    this.$store.dispatch('changeNamePage', 'Controle de Cheques');
    this.loadItems();
    this.loadPhotos();
    this.checkACL();
  },

  data() {
    return {
      itemsOne: {
        title: 'Editar',
        icon: 'edit'
      },

      itemsTwo: {
        route: '/check-management/search',
        icon: 'reply all',
        name: 'Voltar'
      },

      formData: {
        id: this.id,
        client_id: '',
        bank: '',
        agency: '',
        digit_account: '',
        entry_date: '',
        number: '',
        issuer_name: '',
        phone: '',
        email: '',
        value: '0,00',
        due_date: '',
        description: '',
        status: ''
      },

      MONEY,
      photos: [],
      selectedClientName: '',
      openModalClient: false,
      errors: [],
      viewPage: false,
      sendForm: false,
      showError: false
    };
  },

  methods: {
    loadItems() {
      this.$store
        .dispatch('loadCheckManagement', this.id)
        .then(r => {
          this.formData = {
            ...this.formData,
            ...r,
            id: this.id,
            bank: r.bank ? String(r.bank).padStart(3, '0') : '',
            status: r.status ? Number(r.status) : '',
            description: r.description || ''
          };
          this.selectedClientName = r.client_name || '';
        })
        .catch(() => {
          toast.error('Erro desconhecido!', { timeout: 1500 });
        });
    },

    loadPhotos() {
      this.$store
        .dispatch('loadCheckManagementPhotos', this.id)
        .then(r => {
          this.photos = r || [];
        })
        .catch(() => {
          this.photos = [];
        });
    },

    submit() {
      if (!this.sendForm) {
        this.sendForm = true;
        this.$store
          .dispatch('updateCheckManagement', this.formData)
          .then(() => {
            if (!this.formData.status) return;
            return this.$store.dispatch('updateCheckManagementStatus', {
              id: this.formData.id,
              status: this.formData.status
            });
          })
          .then(() => {
            this.showError = false;
            this.sendForm = false;
            this.errors = [];
            toast.success('Cadastro atualizado com sucesso', { timeout: 1500 });
            this.loadItems();
          })
          .catch(e => {
            this.showError = true;
            this.sendForm = false;
            window.scroll(0, 0);
            this.errors = e.response?.data?.errors || [];
            toast.error('Seu formulário contém erros verificar!', { timeout: 2000 });
          });
      }
    },

    handleClientSelection(client) {
      this.formData.client_id = client.id;
      this.selectedClientName = client.surname || client.name;
      this.openModalClient = false;

      this.$store
        .dispatch('loadClient', client.id)
        .then(data => {
          if (data.phones?.length) {
            const phone = data.phones[0];
            this.formData.phone = `${phone.area || ''}${phone.number || ''}`;
          }
          if (data.emails?.length) {
            this.formData.email = data.emails[0].address || data.emails[0].email || '';
          }
        })
        .catch(() => {});
    },

    onFileChange(e) {
      const files = Array.from(e.target.files || []);
      if (!files.length) return;

      const uploads = files.map(file => {
        const formData = new FormData();
        formData.append('id', this.id);
        formData.append('photo', file);
        return this.$store.dispatch('storeCheckManagementPhoto', formData);
      });

      Promise.all(uploads)
        .then(() => {
          toast.success('Fotos enviadas com sucesso', { timeout: 1500 });
          this.loadPhotos();
        })
        .catch(() => {
          toast.error('Erro ao enviar as imagens', { timeout: 1500 });
        })
        .finally(() => {
          e.target.value = '';
        });
    },

    destroyPhoto(item) {
      swal({
        title: 'Atenção!',
        text: 'Deseja realmente deletar a foto?',
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: 'Não',
            visible: true,
            closeModal: true
          },
          confirm: 'Sim'
        }
      }).then(result => {
        if (result) {
          this.$store
            .dispatch('destroyCheckManagementPhoto', item.id)
            .then(() => {
              this.loadPhotos();
              toast.success('Foto deletada com sucesso', { timeout: 1500 });
            })
            .catch(() => {
              toast.error('Não foi possível deletar a foto', { timeout: 1500 });
            });
        }
      });
    },

    async checkACL() {
      this.$store
        .dispatch('ACLItems', 26)
        .then(r => {
          if (r.indexOf('check-management-edit') !== -1) {
            this.viewPage = true;
          } else {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' });
        });
    }
  },

  computed: {
    selectBankList() {
      return this.$store.state.var.selectBankList;
    },

    selectStatusCheckManagement() {
      return this.$store.state.var.selectStatusCheckManagement;
    }
  }
};
</script>

<style scoped>
.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.btn-modal-search {
  padding-top: 9.5px;
  padding-bottom: 5px;
}

.tabs > input,
.tabs > span,
.effect-3 .line {
  width: 50%;
}

#tab-2,
#tab-2 + span,
#tab-2:checked ~ .line {
  left: 50%;
}

.btn-label {
  color: #ffffff;
  border-radius: 0;
  border-color: #000000;
  background-color: #000000;
}

.btn-label:active,
.btn-label:focus,
.btn-label:hover {
  color: #ffffff;
  border-color: #000000 !important;
  background-color: #000000 !important;
}
</style>
